export const excludeMenuList = ['requirement', 'student-requirement', 'online-course', 'notify', 'blog', 'student-blog', 'video', 'setting-requirement', 'enquiry'];
